import type { StepPlan } from "../../../api/content/stepPlans";
import type { WorkflowGraph } from "./workflowGraph";

/** Johannes's two axes of one placement (30 Oct; WD-1+3), as module B's plan gives them: the web decides neither. */
export type PlacementAxes = Pick<StepPlan, "needsPerson" | "usesLlm">;

/**
 * Each step card's axes, by node ID, from the plans of the Workflow shown, by flat step key (a step node's
 * `progressKey`). A card without a plan, such as a producer's step or one the server couldn't plan, has none.
 */
export function placementAxes(graph: WorkflowGraph, plans: ReadonlyMap<string, StepPlan>): ReadonlyMap<string, PlacementAxes> {
  const axes = new Map<string, PlacementAxes>();
  for (const node of graph.nodes) {
    const plan = node.kind === "step" && node.progressKey !== null ? plans.get(node.progressKey) : undefined;
    if (plan !== undefined) {
      axes.set(node.id, { needsPerson: plan.needsPerson, usesLlm: plan.usesLlm });
    }
  }
  return axes;
}
